import { render } from "./deals-details-modal.vue?vue&type=template&id=35285780"
import script from "./deals-details-modal.vue?vue&type=script&lang=js"
export * from "./deals-details-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__